<template>
    <ul class="nav chat-tabs">
      <li class="nav-item justify-content-between" v-for="tab in tabs" :key="tab">
        <a
          href="#"
          class="nav-link"
          :class="{ active: activeTab === tab }"
          @click.prevent="onChange(tab)"
        >
          {{ tab }}
        </a>
      </li>
    </ul>
</template>
  
<script>
    export default {
        name: 'ChatTabs',
        props: {
            activeTab: {
                type: String,
                default: 'All'
            }
        },
        data() {
            return {
                tabs: ['All', 'Open', 'Archived']
            }
        },
        methods: {
            onChange(tab) {
                this.$emit('changeTab', tab)
            }
        }
    }
</script>
  
<style scoped>
    .chat-tabs {
        display: flex;
        width: 100%;
        padding: 0;
        margin: 0;
        list-style: none;
    }
    .chat-tabs .nav-link {
        padding: 0.4rem 0.8rem; 
        font-size: 1.2rem;
        white-space: nowrap;
    }
    .chat-tabs .nav-item {
        flex: 1;
        text-align: center;
    }
    .chat-tabs .nav-link.active {
        font-weight: bold;
    }
</style>
  